/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_Topic_ZonesInputs */

const en_ui_more_stats_topic_zones = /** @type {(inputs: Ui_More_Stats_Topic_ZonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zones`)
};

const de_ui_more_stats_topic_zones = /** @type {(inputs: Ui_More_Stats_Topic_ZonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zonen`)
};

/**
* | output |
* | --- |
* | "Zones" |
*
* @param {Ui_More_Stats_Topic_ZonesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_topic_zones = /** @type {((inputs?: Ui_More_Stats_Topic_ZonesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Topic_ZonesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_topic_zones(inputs)
	return de_ui_more_stats_topic_zones(inputs)
});